/**
 * @fileoverview Main entry point for the Reside application.
 * This file initializes the React application and renders it to the DOM.
 */

import "core-js/features/array/flat-map";
import "core-js/features/object/from-entries";
import "./utils/sentry";
import React from "react";
import ReactDOM from "react-dom";

import {App} from "./App";
import "./bootstrap/validator";

import "./css/index.css";
import "@reside/ui/dist/styles";

/**
 * Renders the main App component to the root DOM element.
 * Also logs environment variables to the console for debugging purposes.
 */
ReactDOM.render(<App />, document.getElementById("root"));

// eslint-disable-next-line no-console
console.table(import.meta.env);
